import { useEffect } from 'react';
import { Providers } from './Providers';
import { AppRouter } from './Router';
import { APP_VERSION } from '@/config/version';
import { setGlobalProperties } from '@/shared/analytics/openpanel';

export function App() {
  useEffect(() => {
    setGlobalProperties({
      app: 'platform',
      env: import.meta.env.MODE,
      appVersion: APP_VERSION,
    });
  }, []);

  return (
    <Providers>
      <AppRouter />
    </Providers>
  );
}
